<script lang="ts">
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import Advertising from './Advertising.svelte';

	const searchParams = getSearchParamsStore();
</script>

<div class="flex items-center justify-center relative">
	{#key $searchParams.selectedPoi?.id}
		<Advertising adId="datasheet" adFormat={{ desktop: '300x600' }} showAdByDefault />
	{/key}
</div>
